import cn from "classnames";
import { Text } from "../../../../packages/ui-kit";
import { ClipIcon, SendChatIcon } from "../../../../packages/icons";
import { useNetworkContext } from "../../../network";
import { useControlContext } from "../../../control";
import { useInputHeightContext } from "../../contexts";
import { DICTIONARY } from "../../dictionary";
import { InputMessageReply } from "./input-message-reply";
import { FileList, MIME_TYPES } from "./files-controller";
import { useChatInput } from "./use-chat-input";
import { useUserTyping } from "./use-user-typing";
import styles from "./chat-input.module.scss";

const ACCEPT = MIME_TYPES.join(", ");

export const ChatInput = () => {
  useUserTyping();
  const { feature } = useControlContext();
  const { textareaRef } = useInputHeightContext();
  const { isMessageSending } = useNetworkContext();

  const {
    message,
    hasMessage,

    files,
    attachedFilesCount,
    hasFiles,
    hasInvalidFiles,

    isFileAttached,
    isFileLimitExhausted,
    isFileLimitExceeded,
    fileInputRef,

    // handleClean,
    handleChange,
    handleClick,
    handleKeyDown,
    handleFileInputChange,
    handleRemoveFile,
  } = useChatInput();

  const { text /* entities */ } = message;

  const hasMessageData = hasMessage || hasFiles;
  const isButtonDisabled = isMessageSending || !hasMessageData;

  const sendStyles = cn(styles.send, {
    [styles.disabled]: isButtonDisabled,
  });

  const availableFilesCountStyles = cn(
    styles["chat-file-input-available-limit"],
    {
      [styles["chat-file-input-available-limit-error"]]: hasInvalidFiles,
    }
  );

  const fileList = (
    <FileList
      files={files}
      hasFiles={hasFiles}
      hasInvalidFiles={hasInvalidFiles}
      isFileAttached={isFileAttached}
      onRemoveClick={handleRemoveFile}
      isFileLimitExceeded={isFileLimitExceeded}
    />
  );

  const replyMessage = <InputMessageReply />;

  const textInput = (
    <textarea
      data-test-id="chat-message-text-input"
      className={styles.input}
      name="text-message"
      value={text}
      placeholder={DICTIONARY.MESSAGE_PLACEHOLDER}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      ref={textareaRef}
    />
  );

  const availableFilesCount = (
    <div
      data-test-id="chat-file-input-available-limit"
      className={availableFilesCountStyles}
    >
      <Text size="xsmall" className={styles["chat-file-input-available-count"]}>
        {attachedFilesCount}
      </Text>
    </div>
  );

  const fileInput = (
    <label
      data-test-id="chat-file-input-label"
      className={styles["file-input"]}
    >
      <input
        data-test-id="chat-file-input"
        type="file"
        accept={ACCEPT}
        hidden
        multiple
        ref={fileInputRef}
        onChange={handleFileInputChange}
        disabled={isFileLimitExhausted || isMessageSending}
      />
      <ClipIcon size="large" />
      {attachedFilesCount && availableFilesCount}
    </label>
  );

  const sendButton = (
    <button
      data-test-id="chat-input-send-button"
      className={sendStyles}
      onClick={handleClick}
      disabled={isButtonDisabled}
    >
      <SendChatIcon size="large" />
    </button>
  );

  return (
    <div className={styles.container}>
      {fileList}
      {replyMessage}
      <div className={styles.control}>
        {feature?.chatFileSending && fileInput}
        {textInput}
        {sendButton}
      </div>
    </div>
  );
};
